/**
 * Canonical public-data corrections tied to the authoritative USPTO filing record.
 *
 * Agentic Action Settlement Governor:
 * U.S. Provisional Application No. 64/084,045
 * Attorney Docket No. SALAR-AASG-001
 *
 * This module normalizes legacy display data without changing any other patent record.
 */
import { patents } from './mockData';
import { LICENSING_PATENTS } from './licensingPatents';
import { PUBLIC_ROUTES } from '../config/routes';

const LEGACY_AASG_NUMBER = '64/085,045';
const CANONICAL_AASG_NUMBER = '64/084,045';

function normalize(value) {
  return typeof value === 'string' ? value.replaceAll(LEGACY_AASG_NUMBER, CANONICAL_AASG_NUMBER) : value;
}

patents.forEach((patent) => {
  if (patent?.id === 8 || patent?.title === 'Agentic Action Settlement Governor') {
    patent.applicationNumber = normalize(patent.applicationNumber);
  }
});

LICENSING_PATENTS.forEach((patent) => {
  if (patent?.num === 8 || patent?.slug === 'patent-8-agentic-settlement-governor') {
    patent.applicationNumber = normalize(patent.applicationNumber);
    patent.metaTitle = normalize(patent.metaTitle);
    patent.metaDescription = normalize(patent.metaDescription);
  }
});

PUBLIC_ROUTES.forEach((route) => {
  route.title = normalize(route.title);
  route.description = normalize(route.description);
});

export { CANONICAL_AASG_NUMBER };
